import React from "react";

const CreatePasscodeIcon = ({ fill }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="23.631"
      height="22.105"
      viewBox="0 0 23.631 22.105"
    >
      <g id="db47" transform="translate(-186.565 -198.797)">
        <path
          id="Path_1293"
          data-name="Path 1293"
          d="M297.066,204.764a6.09,6.09,0,0,0,4.8,5.755.492.492,0,0,0,.118.015.478.478,0,0,0,.118-.015,6.09,6.09,0,0,0,4.8-5.755V201.18a.494.494,0,0,0-.492-.492,5.29,5.29,0,0,1-4.057-1.728.512.512,0,0,0-.748,0,5.289,5.289,0,0,1-4.057,1.728.494.494,0,0,0-.492.492Z"
          transform="translate(-103.608 0)"
          fill={fill ? fill : "#0051bc"}
        />
        <path
          id="Path_1294"
          data-name="Path 1294"
          d="M209.7,426.91H187.058a.494.494,0,0,0-.492.492v6.892a.494.494,0,0,0,.492.492H209.7a.494.494,0,0,0,.492-.492V427.4A.494.494,0,0,0,209.7,426.91ZM193.719,431.9a.49.49,0,0,1-.344.837.5.5,0,0,1-.35-.143l-.551-.551v.778a.492.492,0,1,1-.985,0v-.778l-.551.551a.5.5,0,0,1-.7,0,.49.49,0,0,1,0-.694l1.044-1.049-1.044-1.044a.49.49,0,0,1,0-.694.5.5,0,0,1,.7,0l.552.552v-.783a.492.492,0,0,1,.985,0v.783l.551-.551a.491.491,0,0,1,.694.694l-1.044,1.044Zm6.4,0a.49.49,0,0,1-.345.837.5.5,0,0,1-.35-.143l-.551-.551v.778a.492.492,0,1,1-.985,0v-.778l-.551.551a.5.5,0,0,1-.7,0,.49.49,0,0,1,0-.694l1.044-1.049-1.044-1.044a.49.49,0,0,1,0-.694.5.5,0,0,1,.7,0l.552.552v-.783a.492.492,0,0,1,.985,0v.783l.551-.551a.491.491,0,1,1,.694.694l-1.044,1.044Zm6.4,0a.49.49,0,0,1-.345.837.5.5,0,0,1-.35-.143l-.551-.551v.778a.492.492,0,0,1-.985,0v-.778l-.551.551a.5.5,0,0,1-.7,0,.49.49,0,0,1,0-.694l1.044-1.049-1.044-1.044a.49.49,0,0,1,0-.694.5.5,0,0,1,.7,0l.552.552v-.783a.492.492,0,0,1,.985,0v.783l.551-.551a.491.491,0,0,1,.694.694l-1.044,1.044Z"
          transform="translate(0 -213.885)"
          fill={fill ? fill : "#0051bc"}
        />
      </g>
    </svg>
  );
};

export default CreatePasscodeIcon;
